// src/components/operationCenter/widgets/token/overview/TwSectorHeatWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import SectorHeatCard from "@/components/tokenPage/overview/SectorHeatCard";

const TwSectorHeatWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["fundamentals"]}>
        <SectorHeatCard ticker={config.ticker.toUpperCase()} sectorName={null} />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwSectorHeatWidget;
